import cities from './cities'
import city from './city'
import day from './day'
import month from './month'
import name from './name'

// export { default as cities } from './cities'
// export { default as city } from './city'
// export { default as day } from './day'
// export { default as month } from './month'
// export { default as name } from './name'
export { cities, city, day, month, name }

export default {
  cities, city, day, month, name
}



// WEBPACK FOOTER //
// ./src/index.js